'use strict';

var variables = require('../../variables-1eb6495a.js');

const palette = {
    type: "light",
    primary: {
        light: variables.COLORS.GREEN_PALE,
        main: variables.COLORS.GREEN,
        dark: variables.COLORS.GREEN_DARK,
        contrastText: variables.COLORS.WHITE,
    },
    secondary: {
        light: variables.COLORS.BLUE_PALE,
        main: variables.COLORS.BLUE,
        dark: variables.COLORS.BLUE_DARK,
        contrastText: variables.COLORS.WHITE,
    },
    error: {
        light: variables.COLORS.RED_PALE,
        main: variables.COLORS.RED,
        dark: variables.COLORS.RED_DARK,
        contrastText: variables.COLORS.WHITE,
    },
    warning: {
        light: variables.COLORS.ORANGE_PALE,
        main: variables.COLORS.ORANGE,
        dark: variables.COLORS.ORANGE_DARK,
        contrastText: variables.COLORS.WHITE,
    },
    success: {
        light: variables.COLORS.GREEN_PALE,
        main: variables.COLORS.GREEN,
        dark: variables.COLORS.GREEN_DARK,
        contrastText: variables.COLORS.WHITE,
    },
    info: {
        light: variables.COLORS.BLUE_PALE,
        main: variables.COLORS.BLUE,
        dark: variables.COLORS.BLUE_DARK,
        contrastText: variables.COLORS.WHITE,
    },
    text: {
        primary: variables.COLORS.TEXT_PRIMARY,
        secondary: variables.COLORS.TEXT_SECONDARY,
        disabled: variables.COLORS.GREYSCALE_0_30,
        hint: variables.COLORS.TEXT_SECONDARY,
    },
    action: {
        hover: variables.COLORS.GREYSCALE_0_03,
        hoverOpacity: 0.05,
    },
    flood: {
        amethyst: {
            main: variables.COLORS.PURPLE,
            light: variables.COLORS.PURPLE_PALE,
        },
    },
    background: {
        paper: variables.COLORS.WHITE,
        default: variables.COLORS.GREYSCALE_95,
    },
    divider: variables.COLORS.GREYSCALE_0_15,
};

module.exports = palette;
